import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconCelebrateProps } from './IconCelebrate.types'
import * as Styled from './styles/IconCelebrate.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCelebrate: FC<IconCelebrateProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCelebrateProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconCelebrateProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m12 3 .836 1.7 1.875.269-1.356 1.324.32 1.863L12 7.273l-1.676.883.32-1.863L9.29 4.969l1.875-.27ZM4.246 6.008l1.063.906 1.347-.367-.531 1.293.766 1.172-1.395-.11-.875 1.09-.328-1.36-1.309-.495 1.192-.735Zm15.508 0-1.063.906-1.347-.367.531 1.293-.766 1.172 1.395-.11.875 1.09.328-1.36 1.309-.495-1.192-.735Zm.078 9.023c0-.094.074-.168.168-.172.094 0 .172.079.172.172a.173.173 0 0 1-.168.172.173.173 0 0 1-.172-.172Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M19.96 15.031c0-.02.02-.039.04-.039.023 0 .043.02.043.04 0 .023-.02.042-.043.042-.02 0-.04-.02-.04-.043Zm-15.46 1c0 .278-.223.5-.5.5a.498.498 0 0 1-.5-.5.499.499 0 1 1 1 0Zm15 3c0 .278-.223.5-.5.5a.498.498 0 0 1-.5-.5.499.499 0 1 1 1 0Zm-3.164 2.524a.17.17 0 1 1 .34-.004.17.17 0 0 1-.34.004Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M16.465 21.555c0-.024.02-.04.043-.04a.04.04 0 0 1 .039.04c0 .02-.02.039-.04.039-.023 0-.042-.02-.042-.04ZM12 9.992V19.5m-5.57-8.469 3.129 7.008m8.007-7.008-3.132 7.008m-7.789 1.508c0 .09-.07.164-.16.164a.165.165 0 0 1-.165-.164c0-.086.075-.16.164-.16.09 0 .16.074.16.16Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M6.527 19.547c0 .027-.02.047-.043.047a.045.045 0 0 1-.046-.047c0-.024.019-.043.046-.043.024 0 .043.02.043.043ZM3.66 21.523c0 .09-.074.165-.164.165a.165.165 0 0 1-.164-.165c0-.09.074-.164.164-.164.09 0 .164.075.164.164Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M3.543 21.523a.05.05 0 0 1-.047.047c-.023 0-.043-.023-.043-.047 0-.023.02-.043.043-.043.024 0 .047.02.047.043Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconCelebrate
